const env = {
  version: process.env.REACT_APP_APP_VERSION ?? 'App_Version',
  siteName: process.env.REACT_APP_SITE_NAME ?? '',
  domain: process.env.REACT_APP_DOMAIN_NAME ?? '',
  xbeta: process.env.REACT_APP_ENV ?? '',
  rootUrl: process.env.REACT_APP_ROOT_URL ?? '',
  api: {
    baseUrl: {
      service: process.env.REACT_APP_SERVICE_BASE_URL,
    },
  },
  cookie: {
    domain: process.env.REACT_APP_COOKIE_DOMAIN ?? '',
  },
  pdfDomain: process.env.REACT_APP_PDF_DOMAIN ?? '',
  server1: process.env.REACT_APP_SERVER_1 ?? '0',
  server2: process.env.REACT_APP_SERVER_2 ?? '1',
};

export default env;
